import React from 'react';
import { NavLink } from 'react-router-dom';
//import './styles/css2.css';
import './styles/css1.css';
import { withRouter } from 'react-router'
import Chart from "react-apexcharts"
export default class ReportingDashboard2 extends React.Component {

  constructor(props) {
      var data = null
    super(props);

  this.display_func = this.display_func.bind(this)
  }



  componentDidMount() {

}

display_func = (string) => {
    console.log(string)
}

handle_click = string => e => {
    console.log('click')
    this.display_func(string)
}



  render() {
    return (

                  <div>

                  <button onClick={this.handle_click('a')}>Click</button>

                  </div>

    );
  }
}